/*==============================================================================
GENERAL VARIABLES
==============================================================================*/
var bold = bold || {};


/*==============================================================================
CACHE VARIABLES
==============================================================================*/
bold.cacheVariables = function(){
  bold.cache = {

    //General
    shopMoneyFormat: "",
    $page_container: $('.page-container'),
    $search_form: $('[action="/search"]'),

    //Cart Page
    $cart_link: $('.cart-link'),
    $cart_item_count: $('.header-top-link--cart-count'),
    $checkout: $('.checkout'),
    $create_customer: $('#create_customer'),

    $cart_drawer: $('.cart-drawer'),
    $cart_drawer_inner: $('.cart-drawer-inner'),
    $cart_drawer_close: $('.cart-drawer-close'),
    $cart_drawer_close_class: '.cart-drawer-close',


    // Mobile menu
    $menu_link: $('.menu-link'),
    $menu_drawer: $('.menu-drawer'),
    $menu_drawer_inner: $('.menu-drawer-inner'),
    $menu_drawer_close: $('.menu-drawer-close'),

    //Collection page
    $sort_by: $('.sort-by'),
    $quickview: $('.quickview'),
    $quickview_trigger_serialized: null,

    //Customer page
    $login_form: $('#customer_login'),
    $recover_password_link      : $('.recover-password'),
    $hide_recover_password_link  : $('.hide-recover-password'),
    $recover_password_form      : $('.recover-password-form'),

    //Product page
    $product_selector: $('.product-select'),
    $add_to_cart: $('.add-to-cart'),
    $bundle_quickview: $('.bundle-quickview'),
  }
}


/*==============================================================================
UPDATE CART QUANTITY
==============================================================================*/
bold.updateCustomizerCartQuantity = function(id, qty){
  var quantityValue = parseInt(qty.value);

  $('.'+id+'_qty').each(function(){
      if($(this).attr('data-base-quantity')){
        var baseQuantity = parseInt($(this).attr('data-base-quantity'));
        $(this).val(quantityValue*baseQuantity);
      }
      else {
        $(this).val(quantityValue);
      }
  });
}

bold.removeCustomizerFromCart = function(id){
  $('.'+id+'_qty').val(0);
  $('.'+id+'_qty').parents('form').submit();
}

/*==============================================================================
INITALIZE JS
==============================================================================*/
bold.init = function(){
  bold.cacheVariables();
  bold.collectionSortBy();
  bold.initMenuDrawer();

  bold.quickview();


  bold.initCartDrawer();


  bold.initAjaxCart();

  bold.initLoginForms();

  bold.getCart($('.cart-drawer-form'));

  bold.cache.$search_form.on('submit', function(){

    var value = $(this).find('[name=q]').val();
    $(this).find('[name=q]').attr('name','');
   // $(this).append('<input type="hidden" name="q" value="'+value+' -title:hidden -product_type:OPTIONS_HIDDEN_PRODUCT">');
    $(this).append('<input type="hidden" name="q" value="'+value+'">');


  });

  bold.cache.$create_customer.on('submit', function(){
    $(this).find('.legal-error').remove();
    if(!$(this).find('.legal-agreement').is(':checked')){
      $(this).find('.grid').prepend('<div class="col-12 padding"><div class="errors"><ul><li class="legal-error">Tut mir leid, Du musst unseren Bedingungen zustimmen, um ein Konto zu erstellen.</li></ul></div></div>');
      return false;
    }
  });

  bold.listenForGiftMessageChange($('.cart-page-form'));
}


bold.listenForGiftMessageChange = function($form){

}


/*==============================================================================
COLLECTION SORT BY
==============================================================================*/
bold.collectionSortBy = function(){
  if(bold.cache.$sort_by.length){
    var param_exists = bold.paramExists('sort_by');
    if(param_exists){
      bold.cache.$sort_by.val(param_exists);
    }
    bold.cache.$sort_by.on('change', function(){
      var sort = $(this).val();
      bold.updateUrlParm('sort_by', sort);
    });
  }
}


/*==============================================================================
PRODUCT PAGE
==============================================================================*/
bold.productPage = function(options){
  var money_format = options.money_format;
  var variant = options.variant;
  var selector = options.selector;
  var product_id = options.product_id;
  var $form = $('#product-form-'+product_id);
  var $product_image = $('#featured-image-'+product_id);
  var $product_price = $('.product-price-'+product_id);
  var $compare_price = $('.product-compare-price-'+product_id);
  var $quantity = $form.find('.product-quantity-wrapper');
  var $add_to_cart = $form.find('.addtocart');
  var $shopifyPaymentButton= $('.shopify-payment-button', this.$container);
  var $unitPrice= $('[data-unit-price]', this.$container);
  var $unitPriceBaseUnit= $('[data-unit-price-base-unit]', this.$container);
  var $unitPriceContainer= $('[data-unit-price-container]', this.$container);


  if(variant){

    //Update variant image if one is set
    if(variant.featured_image){
      Shopify.Image.switchImage(variant.featured_image, $product_image[0], bold.switchImage);
    }

    if(variant.available){
      $add_to_cart.removeClass('disabled').prop('disabled', false);
    //  $add_to_cart.html('<i class="zippo-flame"></i> '+"Jetzt kaufen");
      $quantity.show();
    }
    else {
      $add_to_cart.addClass('disabled').prop('disabled', true);
      // $add_to_cart.html('<i class="zippo-flame"></i> '+"Ausverkauft");
      $quantity.hide();
    }

    //Update price
    $product_price.html(Shopify.formatMoney(variant.price, money_format));

    //Update compare price
    if(variant.compare_at_price > variant.price){
      $compare_price.html(Shopify.formatMoney(variant.compare_at_price, money_format)).show();
    }
    else {
      $compare_price.hide();
    }
   // Unit price
  // this.selectors.$unitPriceContainer.addClass('hide');
  // if (variant.unit_price) {
  //   this.selectors.$unitPrice.html(
  //       Shopify.formatMoney(variant.unit_price, theme.moneyFormat)
  //   );
  //   this.selectors.$unitPriceBaseUnit.html(this.getBaseUnit(variant));
  //   this.selectors.$unitPriceContainer.removeClass('hide');
  // }
  }
  else {
    // Disable add to cart if variant doesn't exist
    $add_to_cart.addClass('disabled').prop('disabled', true);
    $add_to_cart.html("Nicht verfügbar");
    $quantity.hide();
  }
}


/*==============================================================================
THUMBNAIL IMAGE SWITCH
==============================================================================*/
bold.productImageSwitch = function (el, options) {
  var product_id = options.product_id;
  var $thumnails = $('#'+el).find('.product-thumb');
  if($thumnails.length){
    $thumnails.on('click', function(event){
      event.preventDefault();
      var $product_image = $('#featured-image-'+product_id),
          $current_image = $('#featured-image-'+product_id).closest('a'),
          $current_href = $current_image.attr('href');
          $gallery_image = $('.product-featured-gallery-item[href="'+$(this).attr('data-large')+'"] img');
      bold.switchImage($(this).attr('data-src'), null, $product_image);
      bold.switchLarge($(this).attr('data-large'), null, $product_image);
      bold.switchImage($current_href, null, $gallery_image);
      bold.switchLarge($current_href, null, $gallery_image);
    });
  }
}


/*==============================================================================
SWITCH IMAGE
==============================================================================*/
bold.switchImage = function(src, image_object, el){
  $(el).attr('src', src);
}
bold.switchLarge = function(src, image_object, el){
  $(el).closest('a').attr('href', src);
}


/*==============================================================================
QUICKVIEW
==============================================================================*/
bold.quickview = function(){
  bold.cache.$quickview.on('click', function(event){
    event.preventDefault();
    var url = $(this).attr('href');
    var target = $(this).attr('href')+'?view=quickview';
    $.magnificPopup.open({
      items: {
        src: target
      },
      type: 'ajax',
      callbacks: {
        ajaxContentAdded: function(){
          // Product page slider on mobile only
          $('.mobile-product-images').slick({
            slide: '.mobile-product-image-slide',
            arrows: false,
            dots: true,
            appendDots: '.product-slider-dots-inner'
          });
        }
      }
    });
  });


  bold.bundleQuickview();
}


bold.bundleQuickview = function(){
  $('.bundle-quickview').on('click', function(event){
    event.preventDefault();
    var url = $(this).attr('href');
    bold.cache.$quickview_trigger_serialized = $(event.target).parents('form').serialize();;
    var target = $(this).attr('href')+'?view=bundle-quickview';
    $.magnificPopup.close();

    setTimeout(function(){
      $.magnificPopup.open({
        items: {
          src: target
        },
        type: 'ajax',
        callbacks: {
          ajaxContentAdded: function(){
            // Product page slider on mobile only
            $('.mobile-product-images').slick({
              slide: '.mobile-product-image-slide',
              arrows: false,
              dots: true,
              appendDots: '.product-slider-dots-inner'
            });
          },
          close: function(){
            if(bold.cache.$quickview_trigger_serialized){
              bold.ajaxCart(null, bold.cache.$quickview_trigger_serialized);
              bold.cache.$quickview_trigger_serialized = null;
            }
          }
        }
      });
    }, 10);
  });
}


/*==============================================================================
INIT MENU DRAWER
==============================================================================*/
bold.initMenuDrawer = function(){
  bold.cache.$menu_link.on('click', function(){
       bold.showMenuDrawer();
       $('.menu-drawer .col-12:first-of-type a').focus();
  });
  bold.cache.$menu_link.on('keypress', function(e){
    if(e.which == 13) {
        bold.showMenuDrawer();
      $('.menu-drawer .col-12:first-of-type a').focus();
      }
  });
  bold.cache.$menu_drawer_close.on('click', bold.closeMenuDrawer);
  bold.cache.$menu_drawer_close.on('keypress', function(e){
    if(e.which == 13) {
        bold.closeMenuDrawer();
      	bold.cache.$menu_link.focus();
      }
  });

  $('.menu-drawer-inner .col-12:last-of-type .menu-drawer-nav-item:last-of-type a').on('keydown', function(e){
      if(!e.shiftKey && e.which == 9) {
        e.preventDefault();
        $('.drawer-top .menu-drawer-close').focus();
      }
 	});



    $('.drawer-top .menu-drawer-close').on('keydown', function(e){
      if(e.shiftKey && e.which == 9) {
        e.preventDefault();
        $('.menu-drawer-inner .col-12:last-of-type .menu-drawer-nav-item:last-of-type a').focus();
      }
    });
}

/*==============================================================================
CHECK MENU DRAWER
==============================================================================*/
bold.checkMenuDrawer = function(event){
  if($(event.target).hasClass('menu-drawer')==false&&$(event.target).parents('.menu-drawer').length==0){
    bold.closeMenuDrawer();
  }
  if($(event.target).parent().hasClass('menu-drawer-continue')){
    event.preventDefault();
    bold.closeMenuDrawer();
  }
}

/*==============================================================================
SHOW MENU DRAWER
==============================================================================*/
bold.showMenuDrawer = function(menu){
  if(menu){
    if(menu.target!=undefined){
      menu.preventDefault();
    }
    else {
      bold.cache.$menu_drawer_inner.html(menu);
    }
  }
  bold.cache.$menu_drawer.addClass('menu-drawer-opened');
  bold.cache.$page_container.addClass('menu-drawer-opened');
  if(!bold.cache.$menu_drawer.hasClass('drawer-opened')){
    bold.cache.$menu_drawer.attr('aria-expanded', 'true');
    setTimeout(function(){
    $('body').on('click', bold.checkMenuDrawer);
  	}, 200);
    $('body').css('overflow','hidden');
  }
  $('body').css('overflow','hidden');
}

/*==============================================================================
CLOSE MENU DRAWER
==============================================================================*/
bold.closeMenuDrawer = function(){
  bold.cache.$menu_drawer.removeClass('menu-drawer-opened');
  bold.cache.$page_container.removeClass('menu-drawer-opened');
  bold.cache.$menu_drawer.attr('aria-expanded', 'false');
  $('body').off('click', bold.checkMenuDrawer);
  $('body').css('overflow','');
}


/*==============================================================================
INIT CART DRAWER
==============================================================================*/
bold.initCartDrawer = function(){

    bold.cache.$cart_drawer.addClass('right-drawer');

  bold.cache.$cart_link.on('click', bold.showCartDrawer);
  $(document).on('click', bold.cache.$cart_drawer_close_class, bold.closeCartDrawer);
  $(document).on('keypress', function(e){
    if(e.which == 13) {
      bold.closeCartDrawer();
      //$('.header-top-link--cart').focus();
    }
  });


}


/*==============================================================================
CHECK CART DRAWER
==============================================================================*/
bold.checkCartDrawer = function(event){
  if($(event.target).hasClass('cart-drawer')==false&&$(event.target).parents('.cart-drawer').length==0){
    bold.closeCartDrawer();
  }
  if($(event.target).parent().hasClass('cart-drawer-continue')){
    event.preventDefault();
    bold.closeCartDrawer();
  }
}


/*==============================================================================
SHOW CART DRAWER
==============================================================================*/
bold.showCartDrawer = function(cart){
  checkFees();
  if(cart){
    if(cart.target!=undefined){
      cart.preventDefault();
    }
    else {
      bold.cache.$cart_drawer_inner.html(cart);
    }
  }



  if(!bold.cache.$cart_drawer.hasClass('drawer-opened')){
    bold.cache.$cart_drawer.addClass('drawer-opened');
    bold.cache.$cart_drawer.attr('aria-expanded', 'true');
    $('.drawer-close').focus();
    bold.cache.$page_container.addClass('drawer-opened');
    setTimeout(function(){
      $('body').on('click', bold.checkCartDrawer);
    }, 100);

    $('.text-left a').on('keydown', function(e){
      if(!e.shiftKey && e.which == 9) {
        e.preventDefault();
        $('.drawer-top .drawer-close').focus();
      }
 	});
    /*
    $('.cart-drawer-bottom-link:last-of-type').on('keydown', function(e){
      if(!e.shiftKey && e.which == 9) {
        e.preventDefault();
        $('.drawer-top .drawer-close').focus();
      }
 	});

	*/
    $('.drawer-close').on('keydown', function(e){
      if(e.shiftKey && e.which == 9) {
        e.preventDefault();
        $('.cart_popout_list .text-left a').focus();
      }
    });

  }


  bold.initCart(bold.cache.$cart_drawer.find('form'));

}


/*==============================================================================
LOAD CART IMAGES
==============================================================================*/
bold.loadCartImages = function(callback){
  var cart_images = $('img:not(.loaded)', bold.cache.$cart_drawer_inner);
  var count = cart_images.length;
  var loaded = 0;

  if(count==0){
    callback();
  }

  cart_images.on('load', function(){
    loaded++;
    $(this).addClass('loaded');

    if(loaded==count){
      if($.type(callback)!="undefined"){
        callback();
      }
    }
  });
}


/*==============================================================================
SIZE TOP DRAWER
==============================================================================*/
bold.sizeTopDrawer = function(){
  var cart_drawer_height = bold.cache.$cart_drawer_inner.outerHeight();
  bold.cache.$cart_drawer.height(cart_drawer_height);
}


/*==============================================================================
CLOSE CART DRAWER
==============================================================================*/
bold.closeCartDrawer = function(){

  bold.cache.$cart_drawer.removeClass('drawer-opened');
  bold.cache.$cart_drawer.attr('aria-expanded', 'false');
  bold.cache.$page_container.removeClass('drawer-opened');

  $('body').off('click', bold.checkCartDrawer);
}



/*==============================================================================
CART
==============================================================================*/
bold.initCart = function($form){
  $form.find('[name="checkout"]').on('click', bold.submitCart);
  $form.on('submit', bold.updateCart);
 // ADDED V.SH
      // This button will increment the value
      $('.qtyplus').click(function(event){
        // Stop acting like a button
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        $(this).prop('disabled', true);

        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[id='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
          bold.updateCart(event, $form);
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(event) {
        // Stop acting like a button
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        $(this).prop('disabled', true);

        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[id='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[id='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[id='+fieldName+']').val(0);
        }
          bold.updateCart(event, $form);
    });
  $form.find('[name="updates[]"]').on('change', function(event){
    bold.updateBundleQuantities(this);
    bold.updateCart(event, $form);
  });
  $form.find('.remove-item').on('click', function(event){
    bold.changeCart(event, $form);
  });

  bold.listenForGiftMessageChange($form);

  bold.validateBundles($('.cart-drawer-form'));
}


bold.setCartAttributeDefaults = function($form){
  if($form.find('.cart-gift-message textarea').val()=='' && $form.find('.gift-toggle:checked')){
    $form.find('.cart-gift-message textarea').val('Yes');
  }
  else {
    $form.find('.cart-gift-message textarea').val('null');
  }
}

bold.updateCart = function(event, $form){
  if(event.preventDefault){
    event.preventDefault();
  }
  var $form = $form || $(event.target);
  var form_data = $form.serialize();
  bold.reloadCart($form, form_data, 'update');
}

bold.changeCart = function(event, $form){
  event.preventDefault();
  var bundleId = $(event.target).attr('data-bundle-group') || $(event.target).parent().attr('data-bundle-group');

  if(bundleId){
    $form.find('input[data-bundle-group="'+bundleId+'"]').val(0);
    bold.reloadCart($form, $form.serialize(), 'update');
  }
  else {
    if($(event.target).attr('class')=='icomoon-close'){
      var $input = $(event.target).parents('a');
    }
    else {
      var $input = $(event.target);
    }
    var href = $input.attr('href').replace(/\r?\n|\r/g, '').replace('/cart/change?','');
    var form_data = $form.serialize();

    if(href != '#'){
      bold.reloadCart($form, href, 'change');
    }
  }
}

bold.reloadCart = function($form, data, method){
  $.ajax({
    type: 'post',
    url: '/cart/'+method+'.js',
    dataType: 'json',
    cache: false,
    data: data,
    success: function(){
      bold.getCart($form);
    }
  });
}

bold.getCart = function($form){
  var view = $form.attr('data-view');
  $.ajax({
    type: 'get',
    url: '/cart',
    cache: false,
    dataType: 'html',
    data: {
      view: view
    },
    success: function(html){
      var $new_form = $form.parents('.cart-drawer-inner').html(html).find('form');
      if($new_form){
        bold.initCart($new_form);
        bold.updateCartCount();
      }
    }
  });
}

bold.updateCartCount = function(){
  $.ajax({
    type: 'get',
    url: '/cart',
    cache: false,
    data: {
      view: 'json'
    },
    dataType: 'html',
    success: function(cart){
      var cart_json = $.parseJSON(cart);
      bold.cache.$cart_item_count.html(cart_json.item_count);
      if(cart_json.item_count>0){
        $('.mobile-cart-count').show();
      }
      else {
        $('.mobile-cart-count').hide();
      }
    }
  });
}

bold.submitCart = function(){
  $(this).parents('form').unbind();
}


/*==============================================================================
INIT AJAX CART
==============================================================================*/
bold.initBundles = function(options){
  bold.bundlePricing(options.productForm, options.priceField);
  options.productForm.find('.bundle-variant').on('change', function(){
    bold.bundlePricing(options.productForm, options.priceField);
  });

  $('.add-bundle').click(function(event){
    bold.cache.$quickview_trigger_serialized = null;
  });
}

bold.bundlePricing = function($form, $priceField){
  var discountPercent = parseFloat($form.find('.bundle-discount').val());
  var price = 0;

  $form.find('.bundle-variant option:selected').each(function(){
    var currentPrice = $(this).attr('data-price')*100;
    var discount = currentPrice * discountPercent;
    price = price + Math.round(currentPrice-discount);
  });
  $priceField.html(Shopify.formatMoney(price));
}

bold.crossSellPricing = function(options){
  options.productForm.find('[name="id"]').on('change', function(){
    var price = $(this).find('option:selected').attr('data-price')*100;
    options.priceField.html(Shopify.formatMoney(price));
  });
}



/*==============================================================================
INIT AJAX CART
==============================================================================*/
bold.initAjaxCart = function(){
  $('[name="add"]').on('click', function(event){
    event.preventDefault();
    var product_id = $(this).closest('form').data("product-id");
    var MyValidateFunction = window["bold_qb_submit_"+product_id];
    var cont = false;
    if(typeof MyValidateFunction == "function"){
      cont = MyValidateFunction(product_id);
    }
    if(cont || typeof MyValidateFunction == "undefined"){
      bold.ajaxCart($(this));
    }
  });
}

/*==============================================================================
AJAX CART
==============================================================================*/
bold.ajaxCart = function($this, serialized_form){
  var form_data;
  if($this){
  	var $form = $this.parents('form');
  	var form_data = $form.serialize();
    $form.find('.cart-add-error').remove();
  }
  else if(serialized_form) {
    form_data = serialized_form;
  }

  $.ajax({
    type: 'post',
    url: '/cart/add.js',
    dataType: 'json',
    data: form_data,
    success: function(data){
      if (typeof(upsell_main) === "function") {
        upsell_main();
      }
      if (typeof(upsell_offer) === "function") {
        upsell_offer();
        $('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){
          ajaxSuccess();
        });
      }
      else {
        ajaxSuccess();
      }
    },
    error: function(data){
      var error = eval('('+data.responseText+')');
      if($this){
      	$form.find('[name="add"]').parent().append('<div class="cart-add-error">'+error.description+'</div>');
      }
    }
  });

  function ajaxSuccess(){
    bold.updateCartCount();
    $.getJSON('/cart', function(cart) {

        $.ajax({
          url: '/cart',
          type: 'get',
          cache: false,
          dataType: 'html',
          data: {
            view: "drawer"
          },
          success: function(cart){
            bold.fetchCart().success(function(fetchedCart){
              $.each(fetchedCart.items, function(index, item){
                if(item.properties && item.properties['_bundle_discount']){
                   if(!item.discounts.length){
                     bold.postCart(fetchedCart);
                     return;
                   }
                   else{
                     var calculatedAmount = parseInt((item.original_line_price * parseFloat(item.properties['_bundle_discount'])).toString().split('.')[0]);
                     var amount = item.discounts[0].amount;
                     if(calculatedAmount !== amount){
                       bold.postCart(fetchedCart);
                       return;
                     }
                   }
                }
              });
            });
            bold.showCartDrawer(cart);
            $.magnificPopup.close();
          }
        });

    });
  }
}



/*==============================================================================
INIT LOGIN FORMS
==============================================================================*/
bold.initLoginForms = function(){
  bold.cache.$recover_password_link.on('click', showRecoverPassword);
  bold.cache.$hide_recover_password_link.on('click', hideRecoverPassword);

  function showRecoverPassword(event){
    bold.cache.$login_form.hide();
    $('.page-title').html('Zresetuj swoje hasło<span class="sub-title">Wyślemy Ci wiadomość e-mail, aby zresetować hasło.</span>');
    bold.cache.$recover_password_form.show();
  }

  function hideRecoverPassword(event){
    bold.cache.$login_form.show();
    $('.page-title').html('Login')
    bold.cache.$recover_password_form.hide();
  }

  if (bold.getHash() == '#recover') {
    showRecoverPassword();
  }
  if (bold.getHash() == '#login') {
    hideRecoverPassword();
  }
}


/*==============================================================================
BOLD SWATCHES
==============================================================================*/
bold.optionSwatches = function(settings){
  var type = settings.type || 'variants';
  var form = settings.form;
  var selector = settings.selector;
  var asset_url = settings.asset_url.split('no-image.png');
  var file_extension = settings.file_extension || '.png';
  var labeled = settings.labeled || false;
  var exclude_options = settings.exclude_options;
  var product = settings.product;
  var $selectors;
  var product_id;

  if(labeled){
    $selectors = $(form).find(selector).filter(function(){
      return $.inArray($(this).prev('label').text(), labeled)>-1;
    });
  }
  else {
    $selectors = $(form).find(selector);
  }

  $selectors.each(function(index){
    var $this = $(this);

    var is_color = false;

    if(type == 'options'){
      var option_label = $this.parents('.shappify_option').find('.shappify_option_name').text().replace(':','').replace('*','');
      if($.inArray(option_label,exclude_options)==-1){
        is_color = true;
      }
    }
    else {
      is_color = product.options[index] == 'Colour' || product.options[index] == 'Color';
    }

    $this.attr('data-swatch-parent',index);
    $this.after('<div class="bold-swatch-container clearfix" data-swatch-index="'+index+'"></div>');

    $this.find('option').each(function(i){
      var value = $(this).text();
      if(value!=''){
        var selected = $(this).is(':selected');
        var this_swatch = $('<input type="radio" id="'+value+'-'+product_id+'" name="swatch-group-'+index+'" value="'+value+'">');
        $(this_swatch).on('change', bold.updateSwatchSelectors);
        $this.next('[data-swatch-index="'+index+'"]').append(this_swatch);
        if(is_color){
          this_swatch.wrap('<div class="bold-swatch-element color"></div>').after('<label class="bold-swatch" for="'+value+'-'+product_id+'" style="background-color: '+value.split(' ').pop().handleize()+'; background-image: url('+asset_url[0]+value.handleize()+file_extension+asset_url[1]+');"></label><div class="tooltip">'+value+'</div>').prop('checked',selected);
        }
        else {
          this_swatch.wrap('<div class="bold-swatch-element"></div>').after('<label class="bold-swatch" for="'+value+'-'+product_id+'">'+value+'</label>').prop('checked',selected);
        }
      }
    });
  });
  $selectors.hide();
}

bold.updateSwatchSelectors = function(){
  var value = $(this).val();
  var $parent_selector = $(this).parents('.bold-swatch-container').prev('select');
  $parent_selector.find('option').filter(function () { return $(this).html() == value; }).prop('selected', true).change();
}


/*==============================================================================
HELPER FUNCTIONS
==============================================================================*/
bold.updateUrlParm = function(param, value){
  var url = document.URL;
  var re = new RegExp("([?&])" + param + "=.*?(&|$)", "i");
  var separator = url.indexOf('?') !== -1 ? "&" : "?";
  if (url.match(re)) {
    window.location.href = url.replace(re, '$1' + param + "=" + value + '$2');
  }
  else {
    window.location.href = url + separator + param + "=" + value;;
  }
}

bold.paramExists = function(param){
  var pairs = location.search.slice(1).split('&');
  var result = {};
  pairs.forEach(function(pair) {
    pair = pair.split('=');
    result[pair[0]] = decodeURIComponent(pair[1] || '');
  });
  var query_json = JSON.parse(JSON.stringify(result));
  return query_json[param];
}

bold.getHash = function(){
  return window.location.hash;
}

String.prototype.handleize = function(){
  return this.replace(/[^\w\s]/gi, '').replace(/ /g,'-').toLowerCase();
}

/*==============================================================================
ADJUST QUANTITIES IN CART
==============================================================================*/
bold.updateBundleQuantities = function(element){
  var quantity = $(element).val();
  var bundleGroup = $(element).attr('data-bundle-group');

  if(bundleGroup){
    $('[data-bundle-group="'+bundleGroup+'"]').val(quantity);
  }

  $('.cart-page-form').submit();
}


/*==============================================================================
ADJUST QUANTITIES IN CART
==============================================================================*/
bold.validateBundles = function($form){
  var changed = false;

  $form.find('[data-bundle-group]').each(function(){
    if(!$(this).hasClass('updated')){
      var bundleGroup = $(this).attr('data-bundle-group');
      var highestQuantity = parseInt($(this).val());


      $form.find('[data-bundle-group="'+bundleGroup+'"]').each(function(){
        var quantity = parseInt($(this).val());
        if(quantity>highestQuantity){
          highestQuantity=quantity;
          changed = true;
        }
      });

      $form.find('[data-bundle-group="'+bundleGroup+'"]').val(highestQuantity);
    }
  });

  if(changed){
    $form.find('[name="updates[]"]').trigger('change');
  }
}



/*==============================================================================
INIT CROSS SELLS
==============================================================================*/
bold.initCrossSells = function(crossSells){
/*  var crossSellQuery = crossSells.map(function(value){
    return 'handle:'+value;
  });

  if(crossSellQuery.length){
    $('[name="checkout"], .cart-drawer-checkout').on('click', function(event){
      event.preventDefault();

      $.magnificPopup.open({
        items: {
          src: '/search?q='+crossSellQuery.join(' OR ')+'&type=product&view=cross_sell'
        },
        type: 'ajax',
        callbacks: {
          ajaxContentAdded: function(){
            bold.ajaxCrossSell();
          },
          parseAjax: function(mfpResponse) {
            if(mfpResponse.data.replace(/(\r\n|\n|\r)/gm,"")==''){
              $('.mfp-bg').hide();
              location.href = '/checkout';
            }
          },
          close: function(){
            location.href = '/checkout';
          }
        }
      });
    });
  }
*/
}


/*==============================================================================
AJAX CROSS SELL
==============================================================================*/
bold.ajaxCrossSell = function(){
  $('.button-add-cross-sell').on('click', function(event){
    event.preventDefault();
    var $btn = $(this);

    var formData = $(this).parents('form').serialize();
    $.ajax({
      type: 'post',
      url: '/cart/add',
      dataType: 'json',
      data: formData,
      success: function(){
        $btn.html('Added');
      }
    });
  });

  $('.button--continue').on('click', function(){
    $.magnificPopup.close();
  });
}

/*==============================================================================
FETCH CART
==============================================================================*/
bold.fetchCart = function(){
  return $.ajax({
    url: '/cart?view=drawer',
    type: 'get',
    dataType: 'json'
  });
};

/*==============================================================================
POST CART TO BOLD ON ERROR
==============================================================================*/

bold.postCart = function(data){
  return $.ajax({
    url: 'https://zippo-app.boldapps.net/front_end/api/saveDebug',
    type: 'post',
    dataType: 'json',
    data: {
      'shop': Shopify.shop,
      'cart': data
    }
  });
};

/*==============================================================================
INITIALIZE BOLDS JS ON DOC READY
==============================================================================*/
$(bold.init);
